export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13433.f69518a9.jpg";